<template>
    <div>
        <!-- <div class="toolBox">
            <Button @click="cancel">返回</Button>
        </div> -->
        <div class="content">
            <div class="boxLeft">
                <div>
                    <a :href="data.webAddress" v-if="data.upLoadType == 'false'" style="display:block;">
                        <img class="image" :src="'/api/file/acquisition/'+data.imageId" alt="">
                    </a>
                    <video-play :data="data" v-if="data.upLoadType == 'true'"></video-play>
                    <div class="instructions">
                        <h2 class="title">{{data.name}}</h2>
                        <p>讲师：{{data.lecturer }}<span>{{data.professional}}</span> </p>
                        <p>专业：{{data.industry}} </p>
                        <p>课程分类：{{data.classType}} </p>
                        <p>课程时长：{{data.duration}}分钟</p>
                        <!-- <p>简介：{{data.synopsis}}</p> -->
                        <div class="brief_box">
                            <div  class="brief_a">
                                <div >
                                    <p class="brief_b">简介</p>        			
                                </div>
                                </div>
                                <div class="brief_hr"></div>
                                <div class="brief_c">
                                    <div class="brief_d">
                                        {{data.synopsis}}
                                    </div>
                                </div>
                                <!-- <div class="brief_hr1" ></div> -->
                        </div>
                        <div class="brief_box">
                            <div  class="brief_a">
                                <div >
                                    <p class="brief_b">详细介绍</p>        			
                                </div>
                                </div>
                                <div class="brief_hr"></div>
                                <div class="brief_c">
                                    <div class="brief_d" v-html="data.content">
                                    </div>
                                </div>
                                <div class="brief_hr1" ></div>
                        </div>
                    </div>
                </div>
                
                <div class="toolBox">
                    <Button @click="cancel" type="primary">返回</Button>
                </div>
            </div>
            <div class="boxRight">
                <leave-message ref="message" @submit="submit" :messages="messages"></leave-message>
            </div>
        </div>
    </div>    
</template>

<script>
import videoPlay from './videoPlay'
import LeaveMessage from "../LeaveMessage/LeaveMessage"
export default {
    components: {
        videoPlay,
        LeaveMessage
    },
    props: {
        id: {

        }
    },
    data() {
        return {
            data: {},
            messages: [],
            ifShow: false
        }
    },
    methods: {
        _initData() {
            let data = {
                id: this.id
            }
            this.$api.video.findVideo(data).then(res => {
                this.data = res.data
                this.searchMessage()
            })
        },
        cancel() {
            this.$emit('cancel')
        },
        submit(value) {
            let data = {
                extension: value,
                ownerId: this.data.id
            }
            this.$api.data.addAttention(data).then(res => {
                this.$refs.message.reSet()
                this.searchMessage()
            })
        },
        searchMessage() {
            let data = {
                ownerId: this.data.id
            }
            this.$api.data.findAttention(data).then(res => {
                this.messages = res.data
                this.ifShow = res.ifShow
            })
        }
    },
    mounted() {
        this._initData()
    }
}
</script>

<style lang="scss" scoped>
    .toolBox{
        margin: 20px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        // border-top: 1px solid #dddddd;
        padding-top: 10px;
    }
    .content{
        &::after {
            content: "";
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
        }
        .videoBox{
            float: left;
        }
        .instructions{
            // float: left;
            font-size: 16px;
            line-height: 32px;
            padding: 0 0 0 20px;
            .title{
                margin-bottom: 20px;
            }
        }
    }
    .image{
        width: 500px;
        height: 300px;
    }
    .boxLeft{
        width: 800px;
        // border-right: 1px solid #dddddd;
        padding-right: 5px;
        float: left;
        margin-right: 40px;
        .title{
            font-size: 20px;
        }
        .artical{
            font-size: 18px;
            padding: 5px 30px;
            text-indent: 2em;
        }
    }
    .boxRight{
        width: 30%;
        padding-left: 10px;
        float: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/Video/CaseInfo.vue